import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import uuidv4 from 'uuid/v4';
import constants from './constants';

var ensureCartId = function ensureCartId() {
  return function (_ref) {
    var id = _ref.id,
        rest = _objectWithoutProperties(_ref, ["id"]);

    return _extends({
      id: id || uuidv4().toString()
    }, rest);
  };
};

var ensureSubjects = function ensureSubjects() {
  return function (_ref2) {
    var subjects = _ref2.subjects,
        rest = _objectWithoutProperties(_ref2, ["subjects"]);

    return _extends({}, rest, {
      subjects: subjects || []
    });
  };
};

var ensureShipping = function ensureShipping() {
  return function (_ref3) {
    var shipping = _ref3.shipping,
        rest = _objectWithoutProperties(_ref3, ["shipping"]);

    return _extends({}, rest, {
      shipping: _extends({
        id: constants.SHIPPING_ID,
        product: constants.SHIPPING_DEFAULT_PRODUCT,
        listPrice: 0,
        listPriceWithTax: 0,
        quantity: 1
      }, shipping)
    });
  };
};

var ensurePayment = function ensurePayment() {
  return function (_ref4) {
    var payment = _ref4.payment,
        rest = _objectWithoutProperties(_ref4, ["payment"]);

    return _extends({}, rest, {
      payment: _extends({
        id: constants.PAYMENT_ID,
        product: constants.PAYMENT_DEFAULT_PRODUCT,
        listPrice: 0,
        listPriceWithTax: 0,
        quantity: 1
      }, payment)
    });
  };
};

var ensureIndirectSubjects = function ensureIndirectSubjects() {
  return function (_ref5) {
    var indirectSubjects = _ref5.indirectSubjects,
        rest = _objectWithoutProperties(_ref5, ["indirectSubjects"]);

    return _extends({}, rest, {
      indirectSubjects: indirectSubjects || []
    });
  };
};

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};

export default function ensureCartElements(cart) {
  return pipe(ensureCartId(), ensureSubjects(), ensureShipping(), ensurePayment(), ensureIndirectSubjects())(cart || {});
}